<template>
  <div v-if="user !== ''">
    <v-row>
      <v-col>
        {{ Usuario }}
        <v-btn @click="salir" color="secondary" x-small dark depressed
          >Salir</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("comun", ["Usuario"]),
    user() {
      let us = this.Usuario;
      let ret = "";
      if (us != undefined && us != null) {
        ret = us;
      }
      return ret;
    },
  },
  methods: {
    ...mapActions("comun", ["desloguear", "quitarUsuario"]),
    ...mapActions("autogestion", ["logout"]),
    ...mapActions("beneficiarios", ["select"]),
    ...mapActions("micrositioefectores", { Salirmicrositio: "logout" }),
    ...mapActions("efectores", { SeleccionarEfector: "select" }),

    salir() {
      if (
        this.$route.path.split("/")[1].toUpperCase() ==
          "AUTOGESTIONBENEFICIARIOS" ||
        this.$route.name.toUpperCase() == "AUTOGESTION"
      ) {
        this.logout();
        this.quitarUsuario();
        this.select(null);
        this.$router.push({ name: "Autogestion" });
      } else {
        if (
          this.$route.path.split("/")[1].toUpperCase() ==
            "MICROSITIOPRESTADORES" ||
          this.$route.name == "Micrositio"
        ) {
          this.Salirmicrositio();
          this.quitarUsuario();
          this.SeleccionarEfector(null);
          this.$router.push({ name: "Micrositio" });
        } else {
          this.desloguear();
        }
      }
    },
  },
};
</script>

<style></style>
